import React from 'react';

export function OFALogo({ variant = 'dark', className = '' }) {
  const color = variant === 'light' ? '#FFFFFF' : '#14274B';
  
  return (
    <svg className={className} viewBox="0 0 504 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* OFA Symbol */}
      <g clipPath="url(#ofa-clip)">
        {/* O */}
        <path d="M153.155 179.635H127.318C102.882 179.635 83 159.753 83 135.318C83 110.882 102.882 91 127.318 91H153.155C177.59 91 197.473 110.882 197.473 135.318C197.473 159.753 177.59 179.635 153.155 179.635ZM127.318 116.5C116.945 116.5 108.5 124.945 108.5 135.318C108.5 145.69 116.945 154.135 127.318 154.135H153.155C163.528 154.135 171.972 145.69 171.972 135.318C171.972 124.945 163.528 116.5 153.155 116.5H127.318Z" fill={color}/>
        {/* A */}
        <path d="M376.813 91H350.976C326.533 91 306.658 110.882 306.658 135.318C306.658 159.753 326.541 179.635 350.976 179.635H376.813C383.533 179.635 389.908 178.12 395.623 175.435V179.59H421.123V135.573C421.123 135.49 421.123 135.4 421.123 135.318C421.131 110.882 401.248 91 376.813 91ZM395.623 135.228V135.573C395.488 145.833 387.103 154.135 376.813 154.135H350.976C340.603 154.135 332.158 145.69 332.158 135.318C332.158 124.945 340.603 116.5 350.976 116.5H376.813C387.156 116.5 395.578 124.893 395.631 135.228H395.623Z" fill={color}/>
        {/* F */}
        <path d="M250.962 91C226.557 91 206.697 110.83 206.645 135.228V135.295C206.645 135.295 206.645 135.31 206.645 135.318V179.59H232.145V159.002L213.102 154.038H240.26H262.82C274.872 154.038 286.077 147.835 292.475 137.62L298.167 128.537H233.412C236.142 121.502 242.975 116.5 250.962 116.5H279.155C291.23 116.5 302.457 110.275 308.847 100.03L314.48 91H250.962Z" fill={color}/>
      </g>
      {/* ACADEMY text */}
      <text 
        x="252" 
        y="235" 
        textAnchor="middle" 
        fill={color} 
        fontFamily="'Poppins', 'Gabarito', sans-serif" 
        fontSize="32" 
        fontWeight="500" 
        letterSpacing="12"
      >
        ACADEMY
      </text>
      <defs>
        <clipPath id="ofa-clip">
          <rect width="338.13" height="88.635" fill="white" transform="translate(83 91)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
